import React, { useEffect, useState } from 'react';
import { getCurrentUser } from '../services/api';

const AuthSuccess: React.FC = () => {
  const [status, setStatus] = useState<'checking' | 'success' | 'cookie-issue' | 'auth-issue'>('checking');
  const [message, setMessage] = useState<string>('Verifying authentication...');

  useEffect(() => {
    // Check authentication status
    const checkAuth = async () => {
      try {
        const userData = await getCurrentUser();
        
        if (userData.authenticated) {
          // Success case
          setStatus('success');
          setMessage('You have successfully authenticated with Google.');
        } else if (userData.tokenPresent) {
          // Cookie exchange happened but something else went wrong
          setStatus('auth-issue');
          setMessage('Cookies were exchanged successfully, but the server is not recognizing your authentication. This might be a session issue.');
        } else {
          // Cookie exchange failed
          setStatus('cookie-issue');
          setMessage('You signed in successfully, but something went wrong with the cookie exchange. Your browser might be blocking third-party cookies.');
        }
      } catch (err) {
        // API call failed
        setStatus('cookie-issue');
        setMessage('Authentication verification failed. There might be an issue with your connection or cookies.');
      }
    };

    checkAuth();
    
    // Redirect to the main app after a delay
    const timer = setTimeout(() => {
      window.location.href = '/';
    }, 5000);
    
    return () => clearTimeout(timer);
  }, []);

  return (
    <div className={`auth-result ${status}`}>
      <h2>
        {status === 'checking' ? 'Verifying Authentication...' : 
         status === 'success' ? 'Authentication Successful!' :
         'Authentication Issue Detected'}
      </h2>
      <p>{message}</p>
      {status !== 'success' && (
        <div className="auth-suggestions">
          <p><strong>Suggestions:</strong></p>
          <ul>
            <li>Make sure cookies are enabled in your browser</li>
            <li>If using Safari, check your privacy settings for cross-site tracking prevention</li>
            <li>Try using a different browser</li>
            <li>Clear your browser cookies and try again</li>
          </ul>
        </div>
      )}
      <p>Redirecting you back to the application...</p>
    </div>
  );
};

export default AuthSuccess; 